export default __webpack_public_path__ + "static/media/exp.1f5ea37a.png";